import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

export default function VehicleSection({ data, onChange, onAddVehicle, onRemoveVehicle, onUpdateVehicle, isOpen, onOpen }) {
  const [collapsed, setCollapsed] = useState(false);
  const { vehicles = [], spouseVehicles = [], maritalStatus, spouseFiling } = data;
  const isSpouseFiling = maritalStatus === "married" && spouseFiling === "yes";

  const renderVehicleCards = (list, prefix) => (
    list.map((vehicle, idx) => (
      <div key={idx} className="grid grid-cols-2 p-0">
        <div className="bg-white rounded-lg shadow-xl p-4 border">
          <div className="flex justify-between items-center mb-2">
            <h4 className="font-medium">Vehicle {idx + 1}</h4>
            <button
              type="button"
              onClick={() => onRemoveVehicle(prefix, idx)}
              className="text-red-500 hover:text-red-700 text-sm"
            >
              Remove
            </button>
          </div>
          <div className = 'w-full bg-white p-1 rounded shadow-xl'>
          <div className="grid grid-cols-12 gap-1 w-full">
            {/* Year - 30% (3 of 12 columns) */}
            <div className="col-span-4">
                <input
                type="text"
                placeholder="Year"
                value={vehicle.year}
                onChange={(e) => onUpdateVehicle(prefix, idx, "year", e.target.value)}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
            </div>

            {/* Make - 70% (9 of 12 columns) */}
            <div className="col-span-8">
                <input
                type="text"
                placeholder="Make"
                value={vehicle.make}
                onChange={(e) => onUpdateVehicle(prefix, idx, "make", e.target.value)}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
            </div>

            {/* Model - 6 of 12 */}
            <div className="col-span-6">
                <input
                type="text"
                placeholder="Model"
                value={vehicle.model}
                onChange={(e) => onUpdateVehicle(prefix, idx, "model", e.target.value)}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
            </div>

            {/* Miles - 6 of 12 */}
            <div className="col-span-6">
                <input
                type="text"
                placeholder="Miles"
                value={vehicle.miles}
                onChange={(e) => onUpdateVehicle(prefix, idx, "miles", e.target.value)}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
            </div>

            {/* Ownership - 6 of 12 */}
            <div className="col-span-6">
                <select
                value={vehicle.ownership}
                onChange={(e) => onUpdateVehicle(prefix, idx, "ownership", e.target.value)}
                className="input w-full"
                >
                <option value="">Ownership</option>
                <option value="sole">Sole</option>
                <option value="joint">Joint</option>
                <option value="third">Third-Party</option>
                </select>
            </div>

            {/* Keep/Let Go - 6 of 12 */}
            <div className="col-span-6 flex gap-2">
                <button
                type="button"
                className={`w-full px-3 py-1 rounded ${vehicle.keep === "keep" ? "bg-blue-500 text-white" : "bg-gray-100"}`}
                onClick={() => onUpdateVehicle(prefix, idx, "keep", "keep")}
                >
                Keep
                </button>
                <button
                type="button"
                className={`w-full px-3 py-1 rounded ${vehicle.keep === "letGo" ? "bg-blue-500 text-white" : "bg-gray-100"}`}
                onClick={() => onUpdateVehicle(prefix, idx, "keep", "letGo")}
                >
                Let Go
                </button>
            </div>
            </div>
            </div>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-4 border">
          <h4 className="text-sm font-medium mb-3">Loan Details</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
            <input
              type="text"
              placeholder="Creditor"
              value={vehicle.creditor}
              onChange={(e) => onUpdateVehicle(prefix, idx, "creditor", e.target.value)}
              className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
            />
            <input
              type="text"
              placeholder="Loan Balance"
              value={vehicle.loanBalance}
              onChange={(e) => onUpdateVehicle(prefix, idx, "loanBalance", e.target.value)}
              className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
            />
            <input
              type="text"
              placeholder="Monthly Payment"
              value={vehicle.monthlyPayment}
              onChange={(e) => onUpdateVehicle(prefix, idx, "monthlyPayment", e.target.value)}
              className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
            />
            <select
              value={vehicle.currentOnPayments}
              onChange={(e) => onUpdateVehicle(prefix, idx, "currentOnPayments", e.target.value)}
              className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
            >
              <option value="">Current on payments?</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
            {vehicle.currentOnPayments === "no" && (
              <input
                type="text"
                placeholder="Months Behind"
                value={vehicle.monthsBehind}
                onChange={(e) => onUpdateVehicle(prefix, idx, "monthsBehind", e.target.value)}
                className="input"
              />
            )}
          </div>
        </div>
      </div>
    ))
  );

  return (
    <section className="space-y-4">
    <div className="flex items-center justify-between bg-gray-100 px-4 py-2 rounded shadow-xl cursor-pointer" onClick={onOpen}>
    <h2 className="text-lg font-semibold text-gray-800">Vehicle Information</h2>
    {isOpen ? <ChevronRightIcon className="w-5 h-5 text-gray-600" /> : <ChevronDownIcon className="w-5 h-5 text-gray-600" />}
    </div>
      {isOpen && (
        <>
          {renderVehicleCards(vehicles, "vehicles")}
          <button
            type="button"
            onClick={() => onAddVehicle("vehicles")}
            className="mt-2 text-blue-600 text-sm"
          >
            + Add Vehicle
          </button>

          {isSpouseFiling && (
            <>
              <h3 className="text-md font-semibold mt-8 mb-2">Spouse Vehicles</h3>
              {renderVehicleCards(spouseVehicles, "spouseVehicles")}
              <button
                type="button"
                onClick={() => onAddVehicle("spouseVehicles")}
                className="mt-2 text-blue-600 text-sm"
              >
                + Add Spouse Vehicle
              </button>
            </>
          )}
        </>
      )}
    </section>
  );
}